import { render, staticRenderFns } from "./GeneralIntakePreventiveCareForm.vue?vue&type=template&id=e1b28ec4"
import script from "./GeneralIntakePreventiveCareForm.vue?vue&type=script&lang=js"
export * from "./GeneralIntakePreventiveCareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports